import { render, staticRenderFns } from "./BeginInfoTable.vue?vue&type=template&id=61339364&scoped=true"
import script from "./BeginInfoTable.vue?vue&type=script&lang=js"
export * from "./BeginInfoTable.vue?vue&type=script&lang=js"
import style0 from "./BeginInfoTable.vue?vue&type=style&index=0&id=61339364&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61339364",
  null
  
)

export default component.exports